import { render } from "./Exams.vue?vue&type=template&id=82d8f2b8&scoped=true"
import script from "./Exams.vue?vue&type=script&lang=js"
export * from "./Exams.vue?vue&type=script&lang=js"

import "./Exams.vue?vue&type=style&index=0&id=82d8f2b8&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\alexk\\Documents\\Clonage Github\\IMS\\IMS\\ims-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82d8f2b8"]])

export default __exports__